import React from 'react'
import { Translate } from "react-redux-i18n";
import {Icon, Button, Dialog, AnchorButton} from "@blueprintjs/core";
import LoadingIndicator from "../../components/LoadingIndicator";
import Image from '../Image';
import ReduxLinkDecorator from "../../containers/ReduxLinkDecorator";
import TranslatedPage from "../../containers/TranslatedPage/TranslatedPage";
class PendingMemberRequest extends React.Component{
  state={
    show_kreditz_dialog:false
  }
  handleClose=()=>{
      this.setState({show_kreditz_dialog: false});
  }
  handleOpen=()=>{
    this.setState({show_kreditz_dialog: true});
  }
  render(){  
    const {user,takeAction, updating, requestId, onMessageClick} = this.props;     
    return (
        <div className="user-item">
            {updating && <LoadingIndicator />}
            {
                !updating && 
                <>
                    <ReduxLinkDecorator goTo={`public-profile/${user.guid}`} >
                        <div className="image user-avatar size-56">
                            <Image
                                src={user.image_url}
                                alt={user.f_name}
                            />
                        </div>
                    </ReduxLinkDecorator>                
                    <div className="meta">
                        <div className="name">{user.f_name} {user.l_name}</div>
                        <div className="context-actions">
                            <a href="#" className="action intent-success inline-flex-center" onClick={()=>{takeAction('accept', requestId)}} >
                                <Icon icon="tick" iconSize="16" className="icon" />{" "}
                                    <Translate value="member_requests.accept" />                     
                            </a>
                            <a href="#" className="action intent-danger inline-flex-center" onClick={()=>{takeAction('reject', requestId)}} >
                                <Icon icon="cross" iconSize="16" className="icon" />{" "}
                                <Translate value="member_requests.reject" />  
                            </a>
                        </div>
                    </div>
                    <div className="user-actions">
                        <Button onClick={_=>onMessageClick(user.guid)} intent="primary secondary-color" icon="chat" />
                    </div>
                </>
            }   
            <div className="identity-check-cta">
                <Button intent="primary" className="primary-outline small" fill={true} onClick={this.handleOpen} >
                    <TranslatedPage path="kreditz.subheading" />
                </Button>

                <Dialog
                    onClose={this.handleClose}
                    title={<TranslatedPage path="kreditz.subheading" />}
                    autoFocus={true}
                    canEscapeKeyClose={true}
                    canOutsideClickClose={true}
                    enforceFocus={true}
                    isOpen={this.state.show_kreditz_dialog}
                    usePortal={true}>
                    <div className="dialog-wrapper">
                        <h4 className="no-top-margin mg-b-8"><TranslatedPage path="kreditz.meta_title" /></h4>
                        <TranslatedPage path="kreditz.content" />
                        <AnchorButton intent="primary" fill={true} target="_blank" href="https://kreditz.com/sv/?utm_source=ihopa&utm_medium=ihopaCTA&utm_campaign=ihopa">
                        <TranslatedPage path="kreditz.meta_description" />
                        </AnchorButton>
                    </div>
                    </Dialog>
            </div>     
        </div>
    )
    }
}

export default PendingMemberRequest;
